import { createRouter, createWebHistory } from 'vue-router';
import GTMAnalyticsController             from '@/js/Webmail/Analytics/GTMAnalyticsController';
import SAPOMailConfigSingleton from '@/SAPOMailConfig';
import ClientLoggingControllerSingleton from '@/js/Webmail/ClientLogging/ClientLoggingController';

const routes = [
  {
    path: '/p',
    name: 'popout',
    component: () => import('@/vue/Views/PopoutView.vue'),
    children: [
      {
        path : '/p/compose',
        name : 'popup-compose',
        component: () => import('@/vue/Views/Compose/ComposePopupView.vue'),
      },

      {
        path : '/p/messages/print/:folder_id/:message_id',
        name : 'popup-message-print',
        component: () => import('@/vue/Views/Messages/MessagePrintPopupView.vue'),
      },

      {
        path : '/p/messages/:folder_id/:message_id',
        name : 'popup-message-open',
        component: () => import('@/vue/Views/Messages/MessageOpenPopupView.vue'),
      },
    ]
  },
  {
    path: '/',
    name: 'home',
    redirect: () => {
      const path = SAPOMailConfigSingleton.server.landing_page
          ? SAPOMailConfigSingleton.server.landing_page
          : '/messages/SU5CT1g';

      return {path: path} 
    },
    component: () => import('@/vue/Views/WebmailView.vue'),

    children: [
      {
        path: '/compose',
        name: 'compose',
        component: () => import('@/vue/Views/Compose/ComposeView.vue'),
      },

      {
        path    : '/messages',
        name    : 'messages',
        redirect: '/messages/SU5CT1g',
      },

      {
        path     : '/messages/:folder_id',
        name     : 'messages-list',
        component: () => import('@/vue/Views/Messages/MessagesView.vue'),
        children : [
          {
            path : ':message_id',
            name: 'message-open',
            component: () => import('@/vue/Views/Messages/MessageView.vue'),
          }
        ]
      },

      {
        path: '/folders',
        name: 'folders',
        component: () => import('@/vue/Views/Folders/FoldersView.vue'),
      },
      {
        path: '/contacts',
        name: 'contacts-list',
        component: () => import('@/vue/Views/Contacts/ContactsView.vue'),
        children : [
          {
            path: 'export',
            name: 'contacts-export',
            component: () => import('@/vue/Views/Contacts/ContactsExportView.vue'),
          },
          {
            path     : 'duplicates',
            name     : 'contacts-duplicates',
            component: () => import('@/vue/Views/Contacts/ContactsDuplicatesView.vue'),
          },
          {
            path     : 'import',
            name     : 'contacts-import',
            component: () => import('@/vue/Views/Contacts/ContactsImportView.vue'),
          },
          {
            path     : 'person',
            name     : 'contacts',
            redirect : '/contacts',
            component: () => import('@/vue/Views/Contacts/ContactsPersonView.vue'),
            children : [
              {
                path: 'info/:contact_id',
                name: 'contacts-person-info',
                component: () => import('@/vue/Views/Contacts/ContactsPersonInfoView.vue'),
              },
              {
                path: 'edit/:contact_id',
                name: 'contacts-person-edit',
                component: () => import('@/vue/Views/Contacts/ContactsPersonFormView.vue'),
              },
              {
                path: 'add',
                name: 'contacts-person-add',
                component: () => import('@/vue/Views/Contacts/ContactsPersonFormView.vue'),
              }
            ]
          },
          {
            path     : 'group',
            name     : 'contacts-group',
            redirect : '/contacts',
            component: () => import('@/vue/Views/Contacts/ContactsGroupView.vue'),
            children : [
              {
                path: 'info/:contact_id',
                name: 'contacts-group-info',
                component: () => import('@/vue/Views/Contacts/ContactsGroupInfoView.vue'),
              },
              {
                path: 'edit/:contact_id',
                name: 'contacts-group-edit',
                component: () => import('@/vue/Views/Contacts/ContactsGroupFormView.vue'),
              },
              {
                path: 'add',
                name: 'contacts-group-add',
                component: () => import('@/vue/Views/Contacts/ContactsGroupFormView.vue'),
              }
            ]
          }
        ]
      },
      {
        path     : 'kids_auth',
        name     : 'kids-auth',
        component: () => import('@/vue/Views/Settings/Kids/KidsAuthView.vue'),
      },
      {
        path     : '/settings',
        name     : 'settings',
        component: () => import('@/vue/Views/Settings/SettingsView.vue'),
        children: [
          {
            path     : 'identities',
            name     : 'identities',
            redirect : '/settings/identities/list',
            component: () => import('@/vue/Views/Settings/Identities/IdentitiesView.vue'),
            children: [
              {
                path     : 'list',
                name     : 'identities-list',
                component: () => import('@/vue/Views/Settings/Identities/IdentitiesListView.vue'),
              },
              {
                path     : 'add',
                name     : 'identities-add',
                component: () => import('@/vue/Views/Settings/Identities/IdentitiesFormView.vue')
              },
              {
                path     : 'edit/:id',
                name     : 'identities-edit',
                component: () => import('@/vue/Views/Settings/Identities/IdentitiesFormView.vue')
              },
            ]
          },
          {
            path     : 'messages_options',
            name     : 'messages-options',
            component: () => import('@/vue/Views/Settings/Messages/MessagesOptionsView.vue'),
          },
          {
            path     : 'messages_forwarding',
            name     : 'messages-forwarding',
            component: () => import('@/vue/Views/Settings/Forwarding/MessagesForwardingView.vue'),
          },
          {
            path     : 'out_of_office',
            name     : 'out-of-office',
            component: () => import('@/vue/Views/Settings/OutOfOffice/OutOfOfficeView.vue'),
          },

          {
            path     : 'imap',
            name     : 'imap-options',
            component: () => import('@/vue/Views/Settings/IMAP/IMAPOptionsView.vue'),
          },

          {
            path     : 'filters',
            name     : 'filters',
            redirect : '/settings/filters/list',
            component: () => import('@/vue/Views/Settings/Filters/FiltersView.vue'),
            children: [
              {
                path     : 'list',
                name     : 'filters-list',
                component: () => import('@/vue/Views/Settings/Filters/FiltersListView.vue'),
              },
              {
                path     : 'info/:id',
                name     : 'filters-info',
                component: () => import('@/vue/Views/Settings/Filters/FiltersInfoView.vue'),
              },
              {
                path     : 'add',
                name     : 'filters-add',
                component: () => import('@/vue/Views/Settings/Filters/FiltersFormView.vue')
              },
              {
                path     : 'edit/:id',
                name     : 'filters-edit',
                component: () => import('@/vue/Views/Settings/Filters/FiltersFormView.vue')
              },
            ]
          },
          {
            path     : 'allowed_emails',
            name     : 'allowed-emails',
            redirect : '/settings/allowed_emails/list',
            component: () => import('@/vue/Views/Settings/AntiSpam/AllowedEmailsView.vue'),
            children: [
              {
                path     : 'list',
                name     : 'allowed-emails-list',
                component: () => import('@/vue/Views/Settings/AntiSpam/AllowedEmailsListView.vue'),
              },
              {
                path     : 'add',
                name     : 'allowed-emails-add',
                component: () => import('@/vue/Views/Settings/AntiSpam/AllowedEmailsFormView.vue'),
              },
            ]
          },
          {
            path     : 'blocked_emails',
            name     : 'blocked-emails',
            redirect : '/settings/blocked_emails/list',
            component: () => import('@/vue/Views/Settings/AntiSpam/BlockedEmailsView.vue'),
            children: [
              {
                path     : 'list',
                name     : 'blocked-emails-list',
                component: () => import('@/vue/Views/Settings/AntiSpam/BlockedEmailsListView.vue'),
              },
              {
                path     : 'add',
                name     : 'blocked-emails-add',
                component: () => import('@/vue/Views/Settings/AntiSpam/BlockedEmailsFormView.vue'),
              },
            ]
          },
          {
            path     : 'smokescreen_addresses',
            name     : 'smokescreen-addresses',
            redirect : '/settings/smokescreen_addresses/list',
            component: () => import('@/vue/Views/Settings/SmokescreenAddresses/SmokescreenAddressesView.vue'),
            children: [
              {
                path     : 'list',
                name     : 'smokescreen-addresses-list',
                component: () => import('@/vue/Views/Settings/SmokescreenAddresses/SmokescreenAddressesListView.vue'),
              },
              {
                path     : 'add',
                name     : 'smokescreen-addresses-add',
                component: () => import('@/vue/Views/Settings/SmokescreenAddresses/SmokescreenAddressesFormView.vue'),
              },
            ]
          },
          {
            path     : 'housekeeper',
            name     : 'housekeeper',
            component: () => import('@/vue/Views/Settings/HouseKeeper/HouseKeeperView.vue'),
          },

          {
            path     : 'notifications',
            name     : 'notifications',
            component: () => import('@/vue/Views/Settings/Notifications/NotificationsView.vue'),
          },

          {
            path     : 'layout',
            name     : 'layout',
            component: () => import('@/vue/Views/Settings/Layout/LayoutView.vue'),
          },
          {
            path     : 'kids',
            name     : 'kids',
            component: () => import('@/vue/Views/Settings/Kids/KidsView.vue'),
          },
        ]
      },
    ]
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/vue/Views/Logout/LogoutView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'page-not-found',
    component: () => import('@/vue/Views/PageNotFoundView.vue'),
  },
]

const router = createRouter({
  history: createWebHistory('/v7#'),
  routes
})

router.afterEach((to, from) => {
  ClientLoggingControllerSingleton.addEntry({
    type: 'page-navigation',
    text: `Navigated to ${to.fullPath} from ${from.fullPath}`,
  });
  GTMAnalyticsController.postVirtualPage(to, from);
});

export default router
